import TesoreriaView from '../TesoreriaView.vue'
import CollectionsList from '../Pages/CollectionsList.vue'

// DEF-ADM-032 — Tesorería. Vive en Administración y no en Ciudad: el reporte
// cruza las ciudades y la ciudad es un filtro más, no el contexto.
//
// Cuelga de TesoreriaView por lo mismo que los tipos de cambio: ese padre es
// el que aporta <page-base>, o sea la barra lateral y la cabecera.
const routes = [
  {
    path: '/tesoreria',
    component: TesoreriaView,
    name: 'tesoreria',
    children: [
      {
        path: 'cobranzas',
        name: 'tesoreria-cobranzas',
        component: CollectionsList,
        meta: { requiresAuth: true }
      }
    ]
  }
]

export default routes
